<div class="support-container">
  <span class="support-icon">
    <span>
      <img class="logo" height="75" loading="lazy" [src]="agentImage | ImageCdn">
    </span>
  </span>
  <div class="supportInfo__info">
    <div class="supportInfo__info-title">
      <app-ds-typography
        [size]="fontSize.XS"
        [fontFamily]="fontFamily.SemiBold"
        [color]="fontColor.Primary"
        [text]="'BOOKING_MODULE.SUPPORT_INFO.TITLE' | transloco">
      </app-ds-typography>
    </div>
    <div class="supportInfo__info-text">
      <app-ds-typography
        [size]="fontSize.XXXS"
        [fontFamily]="fontFamily.Regular"
        [color]="fontColor.Secondary"
        [text]="('BOOKING_MODULE.SUPPORT_INFO.HELP_TEXT' | transloco) + ' ' + supportPhone">
      </app-ds-typography>
    </div>
    <app-ds-button-link
      [fontSize]="fontSize.XXXS"
      [icon]="icons.Whatsapp"
      [iconSize]="16"
      [label]="'BOOKING_MODULE.SUPPORT_INFO.WHATSAPP' | transloco"
      (clickEvent)="goToWhatsappSupport()">
    </app-ds-button-link>
  </div>
</div>
